<script lang="ts" setup>
import { ref } from 'vue'
import { Close } from '@element-plus/icons-vue'
import {
    useFetchApiRequestAsync,
    useOrganizations,
    OrganizationMs,
    useProfileUpdate,
    useActiveOrganization
} from 'auth-package'
import OrganizationAvatar from '@/components/utilities/OrganizationAvatar.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import i18n from '@/i18n'

const { t } = i18n.global
const activeOrganization = useActiveOrganization()
const organizationsRaw = useOrganizations()
const organizations = ref(Object.values(organizationsRaw.value))

async function leaveOrganization(organizationUUId: string) {
    try {
        //INFO:The leave organization is not the same as delete
        /*const leaveOrganization = OrganizationMs.DeleteOrganization().setParameters({
            organizationId: organizationUUId
        })

        const response = await useFetchApiRequestAsync(leaveOrganization)

        if (response) {
            setTimeout(async () => {
                await useProfileUpdate()
            }, 1500)
        }

        return response*/
    } catch (error) {
        console.error('Error: When try to delete organization', error)
    }
}

function leaveOrganizationConfirmBox(organizationUUId: string) {
    ElMessageBox.confirm(t('settings.leaveOrganization'), t('settings.warning'), {
        confirmButtonText: t('settings.leave'),
        cancelButtonText: t('settings.cancel'),
        type: 'warning'
    }).then(async () => {
        const response = await leaveOrganization(organizationUUId)

        if (response) {
            ElMessage({
                type: 'success',
                message: t('settings.leaveComplete')
            })
        } else {
            ElMessage({
                type: 'error',
                message: t('settings.somethingWentWrong')
            })
        }
    })
}

const tableRowClassName = ({ row, rowIndex }: { row: any; rowIndex: number }) => {
    if (row.uuid == activeOrganization?.value.uuid) {
        return 'active-row'
    }
    return ''
}
</script>

<template>
    <el-table
        class="organization-table"
        :data="organizations"
        :row-class-name="tableRowClassName"
        style="width: 100%"
    >
        <el-table-column type="name" label="Name" class="d-flex align-items-center gap-2">
            <template #default="props">
                <OrganizationAvatar
                    :organization="props.row"
                    :marginLeft="0"
                    :marginRight="3"
                    :isActive="props.row.uuid == activeOrganization?.uuid"
                    tooltipDisabled
                />
                <div class="d-inline-flex flex-column ps-1">
                    <div :class="{ 'active-name': props.row.uuid == activeOrganization?.uuid }">
                        {{ props.row.name }}
                    </div>
                    <div>{{ props.row.description }}</div>
                </div>
            </template>
        </el-table-column>
        <el-table-column width="56">
            <template #default="scope">
                <el-tooltip content="Leave organization">
                    <el-button
                        @click="leaveOrganizationConfirmBox(scope.row.uuid)"
                        type="danger"
                        :icon="Close"
                        circle
                        text
                    />
                </el-tooltip>
            </template>
        </el-table-column>
    </el-table>
</template>

<style lang="scss">
.active-row {
    --el-table-tr-bg-color: var(--el-color-primary-light-9);
}

.organization-table {
    .el-table__row {
        .cell {
            gap: 8px;
            display: flex;
            align-items: center;
        }
    }
}

.active-name {
    color: var(--el-color-primary);
}
</style>
